import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';

export interface TaxDataShopmanagerResponse {
    id: number;
    municipal_inscription: string;
    state_inscription: string;
    digital_certificate_password: string;
    tax_regime: string;
    emit_invoice: number;
    emit_invoice_enabled: number;
    focus_id: string;
    csc_nfce_production: string;
    focus_nfe_token: string;
    accounting_cnpj: string;
    can_change_tax_data: boolean;
    focus_global_token: string;
    id_token_nfce_production: string;
    complementary_information_taxpayer: string;
}

export default function useGetTaxDataShopmanager() {
    const queryFn = async () => {
        const { data } = await api.get<TaxDataShopmanagerResponse>(
            '/shopmanagers/tax-data',
        );
        return data;
    };

    return useQuery({
        queryFn,
    });
}
